import React, { useState } from 'react';
import { useTheme } from './ThemeContext';
import { usePartnerModal } from './PartnerModalContext';
import supabase from '../config/supabaseClient';

const PRIMARY_ORANGE = '#FF6600';
const SECONDARY_ORANGE = '#FF8C00';
const BORDER_COLOR = '#E9ECEF';
const SHADOW_LIGHT = '0 4px 15px rgba(0, 0, 0, 0.05)';
const SHADOW_HOVER = `0 12px 30px ${PRIMARY_ORANGE}30, 0 4px 10px ${PRIMARY_ORANGE}15`;

export default function PartnerModal() {
  const { theme } = useTheme();
  const { isPartnerModalOpen, closePartnerModal } = usePartnerModal();
  const [partnerForm, setPartnerForm] = useState({ name: '', email: '', org: '', message: '' });
  const [partnerSent, setPartnerSent] = useState(false);
  const [partnerError, setPartnerError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  if (!isPartnerModalOpen) return null;

  const handlePartnerChange = e => setPartnerForm({ ...partnerForm, [e.target.name]: e.target.value });
  const handlePartnerSubmit = async e => {
    e.preventDefault();
    setPartnerError(null);
    setSubmitting(true);
    const { error } = await supabase.from('etwic_partner_applications').insert([
      {
        name: partnerForm.name,
        email: partnerForm.email,
        organization: partnerForm.org,
        message: partnerForm.message,
      }
    ]);
    setSubmitting(false);
    if (error) {
      setPartnerError('Failed to submit application. Please try again.');
      setPartnerSent(false);
      return;
    }
    setPartnerSent(true);
    setPartnerForm({ name: '', email: '', org: '', message: '' });
    setTimeout(() => {
      setPartnerSent(false);
      closePartnerModal();
    }, 2200);
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.25)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <form onSubmit={handlePartnerSubmit} style={{
        background: 'white', padding: '2.5rem 2rem', borderRadius: '2rem', boxShadow: SHADOW_HOVER, minWidth: 340, maxWidth: 400, width: '100%', display: 'flex', flexDirection: 'column', gap: '1.2rem', position: 'relative',
      }}>
        <button type="button" onClick={closePartnerModal} style={{ position: 'absolute', top: 18, right: 18, background: 'none', border: 'none', fontSize: 22, color: '#888', cursor: 'pointer' }}>×</button>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 700, color: PRIMARY_ORANGE, marginBottom: 8 }}>Become a Partner</h2>
        {partnerSent ? (
          <div style={{ textAlign: 'center', margin: '2rem 0 1rem 0' }}>
            <div style={{ fontSize: 48, color: PRIMARY_ORANGE, marginBottom: 12 }}>✔️</div>
            <div style={{ fontWeight: 600, fontSize: 20, color: '#222', marginBottom: 6 }}>Thank you for your application!</div>
            <div style={{ color: '#666', fontSize: 15 }}>We appreciate your interest in partnering with ETWiC.<br />We will be in touch soon.</div>
          </div>
        ) : <>
          <input name="name" placeholder="Full Name" value={partnerForm.name} onChange={handlePartnerChange} required style={{ padding: '0.9rem 1.1rem', borderRadius: '0.75rem', border: `1.8px solid ${BORDER_COLOR}`, fontSize: '1rem', outline: 'none' }} />
          <input type="email" name="email" placeholder="Email Address" value={partnerForm.email} onChange={handlePartnerChange} required style={{ padding: '0.9rem 1.1rem', borderRadius: '0.75rem', border: `1.8px solid ${BORDER_COLOR}`, fontSize: '1rem', outline: 'none' }} />
          <input name="org" placeholder="Organization" value={partnerForm.org} onChange={handlePartnerChange} style={{ padding: '0.9rem 1.1rem', borderRadius: '0.75rem', border: `1.8px solid ${BORDER_COLOR}`, fontSize: '1rem', outline: 'none' }} />
          <textarea name="message" rows="4" placeholder="Why do you want to partner with us?" value={partnerForm.message} onChange={handlePartnerChange} required style={{ padding: '0.9rem 1.1rem', borderRadius: '0.75rem', border: `1.8px solid ${BORDER_COLOR}`, fontSize: '1rem', outline: 'none', resize: 'none' }} />
          {partnerError && <div style={{ color: 'red', fontWeight: 500, marginBottom: 8 }}>{partnerError}</div>}
          <button type="submit" disabled={submitting} style={{ background: PRIMARY_ORANGE, color: 'white', fontWeight: 600, padding: '0.9rem', borderRadius: '0.75rem', fontSize: '1.1rem', border: 'none', boxShadow: SHADOW_LIGHT, cursor: submitting ? 'not-allowed' : 'pointer', marginTop: 8, opacity: submitting ? 0.7 : 1 }}>
            {submitting ? 'Submitting...' : 'Submit Application'}
          </button>
        </>}
      </form>
    </div>
  );
} 